import React from "react";

import {
  Document, Page, View, StyleSheet, Font, Text,
} from "@react-pdf/renderer";

import RobotoMedium from "../../../../assets/fonts/roboto/Roboto-Medium.ttf";
import Roboto from "../../../../assets/fonts/roboto/Roboto-Regular.ttf";

export default function SchedulingPlanPDF({
  headers = [],
  rows = [],
  getFileName,
}) {
  Font.register({ family: "Roboto-400", src: Roboto });
  Font.register({ family: "Roboto-500", src: RobotoMedium });

  const preferredWidths = {
    "Schedule Date": 12,
    "Submission Name": 16,
    Tests: 18,
    Status: 10,
  };
  const fixedWidth = headers.reduce((sum, header) => sum + (preferredWidths[header] || 0), 0);
  const flexibleCount = headers.filter((header) => !preferredWidths[header]).length || 1;
  const flexibleWidth = Math.max(8, Math.floor((100 - fixedWidth) / flexibleCount));
  const getColumnWidth = (header) => `${preferredWidths[header] || flexibleWidth}%`;

  const styles = StyleSheet.create({
    page: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      padding: "28 24 24 24",
      color: "#1B1F1E",
      fontFamily: "Roboto-400",
      fontSize: 8,
    },
    table: {
      border: "1 solid #E0E6E3",
      borderRadius: 4,
      overflow: "hidden",
    },
    tableHeaderRow: {
      display: "flex",
      flexDirection: "row",
      backgroundColor: "#F1F5F3",
    },
    tableRow: {
      display: "flex",
      flexDirection: "row",
      borderTop: "1 solid #E0E6E3",
    },
    headerCell: {
      padding: "8 4",
      fontFamily: "Roboto-500",
      fontSize: 7,
      borderRight: "1 solid #E0E6E3",
    },
    cell: {
      padding: "6 4",
      fontSize: 7,
      borderRight: "1 solid #E0E6E3",
    },
    cellLast: {
      borderRight: "0",
    },
  });

  return (
    <Document title={getFileName()}>
      <Page size="LETTER" style={styles.page}>
        <View style={styles.table}>
          <View style={styles.tableHeaderRow}>
            {headers.map((header, index) => (
              <Text
                key={`${header}-${index}`}
                style={[
                  styles.headerCell,
                  { width: getColumnWidth(header) },
                  index === headers.length - 1 ? styles.cellLast : null,
                ]}
              >
                {header}
              </Text>
            ))}
          </View>
          {rows.map((row, index) => (
            <View key={`row-${index}`} style={styles.tableRow} wrap={false}>
              {row.map((cell, cellIndex) => (
                <Text
                  key={`cell-${index}-${cellIndex}`}
                  style={[
                    styles.cell,
                    { width: getColumnWidth(headers[cellIndex]) },
                    cellIndex === row.length - 1 ? styles.cellLast : null,
                  ]}
                >
                  {cell === "" || cell == null ? "-" : String(cell)}
                </Text>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
}
